import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Badge, Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import axios from "axios";
import {toast} from "react-toastify";
import {setCDRViewerRequestData, setCDRViewerResponseData, setCDRAvailableTags} from "../../../../_reducers/crmSlice";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import DateBox from "../../../primer/DateBox";
import {getCurrentUser, getGreekCurrencyFormat, isEmpty} from "../../../../_helpers/commonFunctions";
import moment from "moment/moment";
import Input from "../../../common/Input";
import Dropdown from "../../../primer/Dropdown";
import "./callcenter-style.css";
import BetterCheckBox from "../../../common/BetterCheckBox";
import * as XLSX from "xlsx";
import {MdAutoAwesome, MdFileDownload, MdDeselect, MdHistory, MdHourglassEmpty, MdFolderZip, MdError} from "react-icons/md";
import AICallAnalysisModal from "./AICallAnalysisModal";
import SendCDRCallsToAiModal from "../../../primer/POPUP-COMPONENTS/SendCDRCallsToAiModal";
import AICDRTagsModal from "./AICDRTagsModal";
import AILiveChatModal from "./AILiveChatModal";
import AIChatHistoryModal from "./AIChatHistoryModal";

export const CDRViewer = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const requestData = useSelector((state) => state.CRM.cdrViewerRequestData);
    const responseData = useSelector((state) => state.CRM.cdrViewerResponseData);
    const availableTags = useSelector((state) => state.CRM.cdrAiTagResponseData);
    const [loading, setLoading] = useState(false);
    const [pageChanged, setPageChanged] = useState(false);
    const [showTelephonesModal, setShowTelephonesModal] = useState(false);
    const [changedDebugMode, setChangedDebugMode] = useState(false);
    const [showNoAnswerModal, setShowNoAnswerModal] = useState(false);
    const [fetchingRecording, setFetchingRecording] = useState(false);
    const [aiCallTranscription, setAICallTranscription] = useState(null);
    const [aiAnalysisDate, setAiAnalysisDate] = useState(null);
    const [aiCost, setAiCost] = useState(null);
    const [aiLoading, setAiLoading] = useState(false);
    const [processingLinkedId, setProcessingLinkedId] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [showMassSendAiModal, setShowMassSendAiModal] = useState(false);
    const [selectedCall, setSelectedCall] = useState(null);
    const [manualProcessingIds, setManualProcessingIds] = useState([]);
    const [showTagsModal, setShowTagsModal] = useState(false);
    const [showLiveChatModal, setShowLiveChatModal] = useState(false);
    const [showChatHistoryModal, setShowChatHistoryModal] = useState(false);
    const [existingChatSession, setExistingChatSession] = useState(null);
    const [exportingZip, setExportingZip] = useState(false);

    const primerSuffixes = ["389", "1515"];
    const emronSuffixes = ["4895", "6505"];

    const getActualDidsForBackend = () => {
        if (!requestData.did || !Array.isArray(requestData.did) || requestData.did.length === 0) return requestData.did;

        let actualDids = [];
        requestData.did.forEach(d => {
            const didStr = typeof d === 'object' && d !== null ? String(d.value) : String(d);

            if (didStr === "Primer") {
                if (responseData?.dids?.length > 0) {
                    const primerDids = responseData.dids.filter(did => primerSuffixes.some(s => String(did).endsWith(s)));
                    primerDids.forEach(pdid => actualDids.push({value: String(pdid), label: String(pdid)}));
                } else {
                    actualDids.push({value: didStr, label: didStr});
                }
            } else if (didStr === "Emron") {
                if (responseData?.dids?.length > 0) {
                    const emronDids = responseData.dids.filter(did => emronSuffixes.some(s => String(did).endsWith(s)));
                    emronDids.forEach(edid => actualDids.push({value: String(edid), label: String(edid)}));
                } else {
                    actualDids.push({value: didStr, label: didStr});
                }
            } else {
                actualDids.push({value: didStr, label: (typeof d === 'object' ? d.label : didStr)});
            }
        });
        const uniqueDids = [];
        const seen = new Set();
        actualDids.forEach(item => {
            if (!seen.has(item.value)) {
                seen.add(item.value);
                uniqueDids.push(item);
            }
        });

        return uniqueDids;
    };
    const getMappedDefaultDids = () => {
        if (!requestData.did || !Array.isArray(requestData.did)) return [];

        const availableOptions = getDIDOptions();
        let mappedValues = new Set();

        requestData.did.forEach(d => {
            const didStr = typeof d === 'object' && d !== null ? String(d.value) : String(d);
            if (didStr === "Primer" || primerSuffixes.some(s => didStr.endsWith(s))) {
                mappedValues.add("Primer");
            } else if (didStr === "Emron" || emronSuffixes.some(s => didStr.endsWith(s))) {
                mappedValues.add("Emron");
            } else {
                mappedValues.add(didStr);
            }
        });

        return availableOptions.filter(opt => mappedValues.has(opt.value));
    };

    const tableColumns = [
        {
            name: "",
            field: "select_checkbox",
            width: "2%"
        },
        {
            name: "Αρ.",
            field: "sequence",
            width: "3%",
        },
        {
            name: "Ημερομηνία & Ώρα",
            field: "calldate",
            width: "8%",
        },
        {
            name: "Από",
            field: "src",
            width: "10%",
        },
        {
            name: "Προς",
            field: "dst",
            width: "10%",
        },
        {
            name: "disposition",
            field: "disposition",
            width: "5%",
        },
        {
            name: "dcontext",
            field: "dcontext",
            width: "8%",
        },
        {
            name: "lastapp",
            field: "lastapp",
            width: "5%",
        },
        {
            name: "ourIdentification",
            field: "ourIdentification",
            width: "7%",
        },
        {
            name: "Χρόνος Ομιλίας",
            field: "billsec",
            width: "5%",
        },
        {
            name: "Αναμονή",
            field: "waiting",
            width: "5%",
        },
        {
            name: "Ολική Διάρκεια",
            field: "duration",
            width: "5%",
        },
        {
            name: "Θέμα AI",
            field: "AISubject",
            width: "9%",
        },
        {
            name:"AI Tags",
            field: "AITags",
            width: "9%",
        },
        {
            name: "Linked ID",
            field: "linkedid",
            width: "8%",
        },
        {
            name: "Ενέργειες",
            field: "actions",
            width: "7%",
        },
    ]

    const tableColumnsSimpleView = [
        {
            name: "",
            field: "select_checkbox",
            width: "2%"
        },
        {
            name: "Αρ.",
            field: "sequence",
            width: "3%",
        },
        {
            name: "Ημερομηνία & Ώρα",
            field: "calldate",
            width: "8%",
        },
        {
            name: "Από",
            field: "src",
            width: "8%",
        },
        {
            name: "Προς",
            field: "dst",
            width: "8%",
        },
        {
            name: "Πελάτης",
            field: "clientName",
            width: "10%",
        },
        {
            name: "DID",
            field: "did",
            width: "7%",
        },
        {
            name: "Χρόνος Ομιλίας",
            field: "billsec",
            width: "5%",
        },
        {
            name: "Αναμονή",
            field: "waiting",
            width: "5%",
        },
        {
            name: "Ολική Διάρκεια",
            field: "duration",
            width: "5%",
        },
        {
            name: "Θέμα AI",
            field: "AISubject",
            width: "9%",
        },
        {
            name:"AI Tags",
            field: "AITags",
            width: "9%",
        },
        {
            name: "Ενέργειες",
            field: "actions",
            width: "5%",
        },
    ]

    const callTypeOptions = [
        {label: "Μόνο εξερχόμενες", value: "outgoing"},
        {label: "Μόνο εισερχόμενες", value: "incoming"},
        {label: "Μόνο εσωτερικές", value: "inner"}
    ]

    const aiStatusOptions = [
        {label: "Μη απεσταλμένες", value: "not_sent"},
        {label: "Αναμονή Επεξεργασίας", value: "pending"},
        {label: "Σφάλμα", value: "error"},
        {label: "Ολοκληρωμένες", value: "completed"}
    ]

    useEffect(() => {
        if (requestData.firstLoad === true) {
            dispatch(setCDRViewerRequestData({...requestData, firstLoad: false}));
            fetchCDRViewer(false);
        }
    }, [])

    useEffect(() => {
        if (pageChanged === true) {
            setPageChanged(false);
            fetchCDRViewer(false, true);
        }
    }, [pageChanged])

    useEffect(() => {
        if (changedDebugMode === true) {
            setChangedDebugMode(false);
            fetchCDRViewer(false, false);
        }
    }, [changedDebugMode])

    useEffect(() => {
        if (responseData?.data && manualProcessingIds.length > 0) {
            const finishedIds = responseData.data
                .filter(row => manualProcessingIds.includes(String(row.linkedid)) && Number(row.aiStatus) === 100)
                .map(row => String(row.linkedid));

            if (finishedIds.length > 0) {
                setManualProcessingIds(prev => prev.filter(id => !finishedIds.includes(String(id))));
            }
        }

        const processingCalls = responseData?.data?.filter(row =>
            row.aiStatus !== null && row.aiStatus !== undefined && row.aiStatus !== "" &&
            Number(row.aiStatus) >= 0 && Number(row.aiStatus) < 100
        ) || [];

        let interval;
        if (processingCalls.length > 0) {
            const processingIds = processingCalls.map(c => c.linkedid);

            interval = setInterval(() => {
                axios.post(`${process.env.REACT_APP_API_URL2}/ai/check-ai-status`, { linkedIds: processingIds })
                    .then(res => {
                        if (res.data && res.data.status === "200" && Array.isArray(res.data.data)) {
                            const newStatuses = res.data.data;
                            let hasChanges = false;
                            let newlyAnalyzedCost = 0;
                            let newlyAnalyzedCallsCount = 0;
                            let localSkippedOrFinishedCount = 0;

                            const updatedData = responseData.data.map(call => {
                                const matchedUpdate = newStatuses.find(ns => Number(ns.linked_id) === Number(call.linkedid));

                                if (matchedUpdate) {
                                    const backendStatus = Number(matchedUpdate.aiStatus);
                                    const currentStatus = Number(call.aiStatus);

                                    if (backendStatus === 4 && manualProcessingIds.includes(String(call.linkedid))) {
                                        hasChanges = true;
                                        localSkippedOrFinishedCount += 1;
                                        setManualProcessingIds(prev => prev.filter(id => String(id) !== String(call.linkedid)));

                                        return {
                                            ...call,
                                            aiStatus: 4,
                                            hasAiAnalysis: false,
                                            aiTags: [],
                                            aiMainSubject: "Μικρή διάρκεια ή σφάλμα αρχείου ήχου"
                                        };
                                    }

                                    if (String(matchedUpdate.aiStatus) !== String(call.aiStatus)) {
                                        hasChanges = true;

                                        if ((backendStatus === 100 || backendStatus < 0) && manualProcessingIds.includes(String(call.linkedid))) {
                                            localSkippedOrFinishedCount += 1;
                                            setManualProcessingIds(prev => prev.filter(id => String(id) !== String(call.linkedid)));
                                        }

                                        if (backendStatus === 100 && currentStatus !== 100) {
                                            if (matchedUpdate.aiCost) {
                                                newlyAnalyzedCost += Number(matchedUpdate.aiCost);
                                            }
                                            newlyAnalyzedCallsCount += 1;
                                        }

                                        return {
                                            ...call,
                                            aiStatus: backendStatus,
                                            hasAiAnalysis: backendStatus === 100,
                                            aiTags: backendStatus === 100 && matchedUpdate.aiJSONResponse?.tags ? matchedUpdate.aiJSONResponse.tags : [],
                                            aiMainSubject: backendStatus === 100 && matchedUpdate.aiJSONResponse?.mainSubject ? matchedUpdate.aiJSONResponse.mainSubject : ""
                                        };
                                    }
                                }
                                return call;
                            });

                            if (hasChanges) {
                                const newTotalCost = (Number(responseData?.stats?.totalAiCost) || 0) + newlyAnalyzedCost;
                                const newTotalCalls = (Number(responseData?.stats?.totalAiAnalyzedCalls) || 0) + newlyAnalyzedCallsCount;
                                const realProcessingLeft = newStatuses.filter(ns =>
                                    Number(ns.aiStatus) >= 0 &&
                                    Number(ns.aiStatus) < 100 &&
                                    Number(ns.aiStatus) !== 4
                                ).length;

                                const updatedStats = {
                                    ...responseData.stats,
                                    totalAiCost: +newTotalCost.toFixed(4),
                                    totalAiAnalyzedCalls: newTotalCalls,
                                    totalProcessingCalls: realProcessingLeft
                                };

                                dispatch(setCDRViewerResponseData({
                                    ...responseData,
                                    data: updatedData,
                                    stats: updatedStats
                                }));
                            }
                        }
                    })
                    .catch(error => console.error("Polling AI Status Error:", error));
            }, 5000);
        }

        return () => {
            if (interval) clearInterval(interval);
        };
    }, [responseData?.data, manualProcessingIds]);

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL2 + "/ai/get-cdr-tags")
            .then(res => {
                if (res.data.status === "200") {
                    dispatch(setCDRAvailableTags(res.data.data));
                }
            }).catch(err => console.log("Error fetching AI tags:", err));
    }, [])

    const handleSelectRow = (e, linkedid) => {
        e.stopPropagation();
        const idStr = String(linkedid);
        const exists = selectedRows.includes(idStr);
        if (exists) {
            setSelectedRows((prev) => prev.filter((id) => id !== idStr));
        } else {
            setSelectedRows((prev) => [...prev, idStr]);
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(["-1"]);
        } else {
            setSelectedRows([]);
        }
    };

    const isAllChecked = (selectedRows.length === 1 && selectedRows[0] === "-1") ||
        (selectedRows.length === requestData.totalItems && !selectedRows.includes("-1"));

    const handleFilterChange = (e, type, name) => {
        const prepChanges = {};
        if (type === "datebox") {
            prepChanges["needsFetch"] = true;
            if (moment(e).isValid()) {
                prepChanges[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChanges[name] = "";
            }
        } else if (type === "input") {
            prepChanges[name] = e.target.value;
        } else if (type === "dropdown") {
            prepChanges[name] = e.value;
        } else if (type === "checkbox") {
            prepChanges[name] = e.target.checked;
            setChangedDebugMode(true);
        } else if (type === "msdd") {
            if (name === "tags") {
                prepChanges[name] = e.map(item => item.value || item);
            } else {
                prepChanges[name] = e;
            }
        }
        dispatch(setCDRViewerRequestData({...requestData, ...prepChanges}));
    }

    const fetchCDRViewer = (forceRefresh, fromPagination = false, isSilent = false) => {
        if (!isSilent) setLoading(true);
        if (!fromPagination) setSelectedRows([]);

        let newReqData = {
            ...requestData,
            did: getActualDidsForBackend(),
            forceRefresh: forceRefresh,
            company: company.id,
            fromPagination: fromPagination,
            userId: getCurrentUser()._id,
        }
        if (!fromPagination) newReqData.page = 1;
        axios.post(process.env.REACT_APP_API_URL2 + "/callcenter/fetch-cdr-viewer", newReqData, {
            headers: {"Content-Type": "application/json"},
        }).then((res) => {
            if (!isSilent) setLoading(false);
            if (res.data.status === "200") {
                let prepObj = {
                    ...responseData,
                    data: res.data.data,
                    devices: res.data.devices,
                    dids: res.data.dids,
                    queues: res.data.queues,
                    ivrs: res.data.ivrs,
                    lastUpdate: res.data.lastUpdate,
                    totals: res.data.totals,
                    totalsPerInner: res.data.totalsPerInner,
                    totalPages: res.data.totalPages
                }

                if (!fromPagination) {
                    prepObj.stats = res.data.stats;
                } else {
                    prepObj.stats = {
                        ...responseData.stats,
                        totalProcessingCalls: res.data.stats?.totalProcessingCalls !== undefined ? res.data.stats.totalProcessingCalls : responseData.stats?.totalProcessingCalls,
                        totalAiAnalyzedCalls: res.data.stats?.totalAiAnalyzedCalls !== undefined ? res.data.stats.totalAiAnalyzedCalls : responseData.stats?.totalAiAnalyzedCalls,
                        totalAiCost: res.data.stats?.totalAiCost !== undefined ? res.data.stats.totalAiCost : responseData.stats?.totalAiCost
                    };
                }
                dispatch(setCDRViewerResponseData(prepObj));

                if (forceRefresh) {
                    toast.success("Data fetched.");
                    dispatch(setCDRViewerRequestData({
                        ...requestData,
                        page: 1,
                        callType: [],
                        srcdst: "",
                        did: [],
                        queue: [],
                        tags: [],
                        client: "",
                        firstLoad: false,
                        needsFetch: false,
                        date_from: res.data.filters.date_from,
                        date_to: res.data.filters.date_to,
                        totalItems: res.data.totalItems,
                    }));
                } else if (!fromPagination) {
                    dispatch(setCDRViewerRequestData({
                        ...requestData,
                        page: 1,
                        firstLoad: false,
                        date_from: res.data.filters.date_from,
                        date_to: res.data.filters.date_to,
                        totalItems: res.data.totalItems
                    }));
                } else {
                    dispatch(setCDRViewerRequestData({
                        ...requestData,
                        firstLoad: false,
                        totalItems: res.data.totalItems
                    }));
                }
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            if (!isSilent) setLoading(false);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            console.log(err);
        })
    }

    const fetchRecording = (row) => {
        if (fetchingRecording) {
            toast.info("Παρακαλώ περιμένετε να κατέβει η προηγούμενη ηχογράφηση.");
        } else {
            if (row.recordingfile) {
                setLoading(true);
                setFetchingRecording(true);
                axios.post(process.env.REACT_APP_API_URL2 + "/callcenter/fetch-recorded-call", {
                    company: company.id,
                    recordingfile: row.recordingfile,
                    calldate: row.calldate,
                    userId: getCurrentUser()._id
                }, {
                    headers: {"Content-Type": "application/json"},
                }).then((res) => {
                    if (res.data.status === "200") {
                        toast.info("Η ηχογράφηση βρέθηκε και θα κατέβει σύντομα...");
                        const bytes = Uint8Array.from(atob(res.data.data), c => c.charCodeAt(0));
                        const blob = new Blob([bytes], { type: 'audio/wav' });
                        const url = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = row.recordingfile || "Recording.wav";
                        document.body.appendChild(link);
                        link.click();
                        setTimeout(() => {
                            document.body.removeChild(link);
                            URL.revokeObjectURL(url);
                        }, 200)
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch((error) => {
                    console.log(error);
                    toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
                }).finally(() => {
                    setFetchingRecording(false);
                    setLoading(false);
                })
            } else {
                toast.error("Η κλήση αυτή δεν έχει καταγραφεί.");
            }
        }
    }

    const firstPage = () => {
        dispatch(setCDRViewerRequestData({...requestData, page: 1}));
        setPageChanged(true);
    }
    const previousPage = () => {
        dispatch(setCDRViewerRequestData({...requestData, page: requestData.page - 1}));
        setPageChanged(true);
    }
    const nextPage = () => {
        dispatch(setCDRViewerRequestData({...requestData, page: requestData.page + 1}));
        setPageChanged(true);
    }
    const lastPage = () => {
        dispatch(setCDRViewerRequestData({...requestData, page: responseData.totalPages}));
        setPageChanged(true);
    }
    const getDIDOptions = () => {
        let opt = [];
        let hasPrimer = false;
        let hasEmron = false;

        if (responseData && responseData.dids?.length > 0) {
            for (let did of responseData.dids) {
                const didStr = String(did);
                if (primerSuffixes.some(s => didStr.endsWith(s))) {
                    if (!hasPrimer) {
                        opt.push({value: "Primer", label: "Primer"});
                        hasPrimer = true;
                    }
                } else if (emronSuffixes.some(s => didStr.endsWith(s))) {
                    if (!hasEmron) {
                        opt.push({value: "Emron", label: "Emron"});
                        hasEmron = true;
                    }
                } else {
                    opt.push({value: didStr, label: didStr});
                }
            }
        }
        return opt;
    }
    const getQueuesOptions = () => {
        let opt = [];
        if (responseData && responseData.queues?.length > 0) {
            for (let queue of responseData.queues) {
                opt.push({value: queue.extension, label: queue.descr});
            }
        }
        return opt;
    }
    const handleTelephoneClick = (device) => {
        setShowTelephonesModal(false);
        dispatch(setCDRViewerRequestData({...requestData, srcdst: isEmpty(requestData.srcdst) ? device.user : String(requestData.srcdst) + `,${device.user}`}));
    }
    const minutesDoubleToText = (minutes) => {
        let resp;
        let totalMinutes = Math.floor(Number(minutes));
        let secondsAsDouble = Number(minutes) - Number(totalMinutes);
        secondsAsDouble = secondsAsDouble * 60;
        secondsAsDouble = Math.round(secondsAsDouble);
        if (totalMinutes === 0) {
            if (secondsAsDouble === 1) {
                resp = "1 δευτερόλεπτο"
            } else {
                resp = `${secondsAsDouble} δευτερόλεπτα`
            }
        } else if (totalMinutes === 1) {
            if (secondsAsDouble === 1) {
                resp = "1 λεπτό και 1 δευτερόλεπτο"
            } else {
                resp = `1 λεπτό και ${secondsAsDouble} δευτερόλεπτα`
            }
        } else {
            if (secondsAsDouble === 1) {
                resp = `${totalMinutes} λεπτά και 1 δευτερόλεπτο`
            } else {
                resp = `${totalMinutes} λεπτά και ${secondsAsDouble} δευτερόλεπτα`
            }
        }
        return resp;
    }
    const secondsToMinutesSeconds = (seconds) => {
        const totalMinutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds - 60*totalMinutes;
        if(String(remainingSeconds).length === 1) {
            return <>{totalMinutes}{":"}{"0" + remainingSeconds}</>
        } else {
            return <>{totalMinutes}{":"}{remainingSeconds}</>
        }
    }
    const handleExcelExport = async () => {
        let rows = [];
        try {
            setLoading(true);
            const apiResponse = await axios.post(process.env.REACT_APP_API_URL2 + "/callcenter/fetch-cdr-viewer", {
                ...requestData,
                did: getActualDidsForBackend(),
                debugMode: false,
                page: -1,
                forceRefresh: false,
                company: company.id,
                fromPagination: false,
                userId: getCurrentUser()._id,
            }, {
                headers: {"Content-Type": "application/json"},
            })
            if (apiResponse?.data?.status === "200") {
                if (apiResponse?.data?.data?.length > 0) {
                    rows.push(["Στατιστικά"]);
                    rows.push([]);
                    rows.push(["Συνολικές κλήσεις", apiResponse?.data.stats.totalInboundCalls + apiResponse?.data.stats.totalOutboundCalls]);
                    rows.push([]);
                    rows.push(["Συνολικές εισερχόμενες κλήσεις", apiResponse?.data.stats.totalInboundCalls]);
                    rows.push([]);
                    rows.push(["Συνολικές εξερχόμενες κλήσεις", apiResponse?.data.stats.totalOutboundCalls]);
                    rows.push([]);
                    rows.push(["Πλήθος εισερχόμενων κλήσεων που δεν απαντήθηκαν", apiResponse?.data.stats.noAnswer]);
                    rows.push([]);
                    if (Object.keys(apiResponse?.data.stats.meanDidWaitingTime).length > 0) {
                        rows.push(["Μέσος χρόνος αναμονής ανά DID"])
                        Object.keys(apiResponse?.data.stats.meanDidWaitingTime).forEach((did) => {
                            rows.push([did + " : " + minutesDoubleToText(apiResponse?.data.stats.meanDidWaitingTime[did])]);
                        })
                    }
                    rows.push([]);
                    if (Object.keys(apiResponse?.data.stats.maxSimultaneousCalls).length > 0) {
                        rows.push(["Πλήθος μέγιστων κλήσεων ανά DID"]);
                        Object.keys(apiResponse?.data.stats.maxSimultaneousCalls).forEach((did) => {
                            rows.push([did + " : " + apiResponse?.data.stats.maxSimultaneousCalls[did]]);
                        })
                    }
                    rows.push([]);
                    let prepHeader = [];
                    for (let col of tableColumnsSimpleView.filter((col) => col.field !== "actions")) {
                        prepHeader.push(col.name);
                    }
                    rows.push(prepHeader);
                    for (let row of apiResponse.data.data) {
                        let prepRow = [];
                        for (let col of tableColumnsSimpleView) {
                            if (col.field === "waiting") {
                                prepRow.push(Number(row.duration) - Number(row.billsec));
                            } else if (col.field === "calldate") {
                                prepRow.push(moment(row.calldate).format("DD/MM/YYYY HH:mm:ss"));
                            } else {
                                prepRow.push(row[col.field]);
                            }
                        }
                        rows.push(prepRow);
                    }
                    const workSheet = XLSX.utils.aoa_to_sheet(rows);
                    const workBook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workBook, workSheet, "Αναφορά Τηλεφωνικού");
                    XLSX.writeFile(workBook, 'Αναφορά Τηλεφωνικού.xlsx');
                } else {
                    toast.info("Δεν βρέθηκαν δεδομένα με αυτά τα φίλτρα.");
                }
                setLoading(false);
            } else {
                setLoading(false);
                if (apiResponse?.data?.message) {
                    toast.error(apiResponse.data.message);
                } else {
                    toast.error("Εσωτερικό σφάλμα κατά την αναζήτηση δεδομένων.");
                }
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }
    }

    const handleMassTranscriptExport = async () => {
        setExportingZip(true);

        try {
            const payloadRows = selectedRows.length === 0 ? ["-1"] : selectedRows;
            const response = await axios.post(`${process.env.REACT_APP_API_URL2}/ai/mass-export-transcripts`, {
                selectedRows: payloadRows,
                filters: {
                    ...requestData,
                    did: getActualDidsForBackend()
                }
            }, {
                responseType: 'blob',
                headers: { 'Accept': 'application/zip' }
            });

            if (response.data.type === 'application/json') {
                const text = await response.data.text();
                const data = JSON.parse(text);
                toast.error(data.message || "Σφάλμα κατά την εξαγωγή.");
                setExportingZip(false);
                return;
            }

            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            const contentDisposition = response.headers['content-disposition'];
            let fileName = `Mass_Transcripts_${moment().format("DD_MM_YYYY")}.zip`;
            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (fileNameMatch && fileNameMatch.length === 2) {
                    fileName = fileNameMatch[1];
                }
            }

            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);

            toast.success("Η εξαγωγή ολοκληρώθηκε επιτυχώς!");
        } catch (error) {
            console.error("Export Error:", error);
            toast.error("Σφάλμα κατά την εξαγωγή των transcripts.");
        } finally {
            setExportingZip(false);
        }
    };

    const dcontextToIvr = (dc) => {
        let str = dc;
        const split = dc.split("-");
        if (split[0] === "ivr" && !isNaN(split[1]) && responseData?.ivrs?.length > 0) {
            const findIVR = responseData.ivrs.find((el) => Number(split[1]) === Number(el.id));
            if (findIVR) {
                str = `IVR (${findIVR.name})`
            } else {
                str = `Μενού ${dc}`
            }
        }
        return str;
    }

    const handleClickAi = (row) => {
        const l_id = row.linkedid;
        setSelectedCall(row);
        setAiLoading(true);
        setProcessingLinkedId(l_id);

        axios.get(`${process.env.REACT_APP_API_URL2}/ai/ai-cdrcall-result/${l_id}`)
            .then((res) => {
                if (res.data && res.data.status === "200") {
                    setAICallTranscription(res.data.aiJSONResponse);
                    setAiAnalysisDate(res.data.createdAt);
                    setAiCost(res.data.aiCost);
                    setAiLoading(false);
                } else {
                    toast.error("Η ανάλυση δεν βρέθηκε.");
                    setAiLoading(false);
                }
            })
            .catch((err) => {
                console.error("Error fetching AI result:", err);
                setAiLoading(false);
                toast.error("Σφάλμα κατά την ανάκτηση.");
            });
    };

    const attemptFetchResult = (linkedid) => {
        axios.get(`${process.env.REACT_APP_API_URL2}/ai/ai-cdrcall-result/${linkedid}`)
            .then(res => {
                if (res.data.aiStatus === 100) {
                    setAICallTranscription(res.data.aiJSONResponse);
                    setAiAnalysisDate(res.data.createdAt);
                    setAiCost(res.data.aiCost);
                    setAiLoading(false);
                    setProcessingLinkedId(null);
                } else if (res.data.aiStatus < 0) {
                    toast.error("Η ανάλυση απέτυχε.");
                    setAiLoading(false);
                    setProcessingLinkedId(null);
                } else {
                    setTimeout(() => attemptFetchResult(linkedid), 3000);
                }
            })
            .catch(() => {
                setAiLoading(false);
                setProcessingLinkedId(null);
            });
    };

    const dynamicTagsOptions = availableTags?.map(tag => ({
        label: `${tag.name} - ${tag.forCompany}`,
        value: `${tag.name} | ${tag.forCompany}`,
        ...tag
    })) || [];

    return (
        <div onKeyDown={(e) => {
            if (e.key === "Enter") fetchCDRViewer(false)}
        }>
            <Row>
                <Col md={2}>
                    <DateHelper
                        dateFromAndToFunction={(from, to) => dispatch(setCDRViewerRequestData({...requestData, date_from: from, date_to: to}))}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name="date_from"
                        selected={isEmpty(requestData.date_from) ? moment().toDate() : moment(requestData.date_from, "DD/MM/YYYY").toDate()}
                        label={"Ημερομηνία από"}
                        onChange={(e) => handleFilterChange(e, "datebox", "date_from")}
                        allowOtherYears={true}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name="date_to"
                        selected={isEmpty(requestData.date_to) ? moment().toDate() : moment(requestData.date_to, "DD/MM/YYYY").toDate()}
                        label={"Ημερομηνία έως"}
                        onChange={(e) => handleFilterChange(e, "datebox", "date_to")}
                        allowOtherYears={true}
                    />
                </Col>
                <Col md={1}>
                    {!isEmpty(responseData.lastUpdate) && (
                        <Badge bg={"primary"} className={"mt-3"}>
                            Τελευταία ανανέωση: <br/>
                            {moment(responseData.lastUpdate).format("DD/MM/YYYY HH:mm:ss")}
                        </Badge>
                    )}
                </Col>
                <Col md={3}>
                    <Button onClick={() => fetchCDRViewer(true)} disabled={loading}>Ανανέωση Δεδομένων από το Τηλεφωνικό κέντρο {loading && <Spinner animation="border" variant="dark" />}</Button>
                    {requestData.needsFetch && (
                        <React.Fragment>
                            <br/>
                            <div style={{textAlign: "center"}}>Το φίλτρο της ημερομηνίας έχει αλλάξει, παρακαλώ
                                ανανεώστε από το τηλεφωνικό
                            </div>
                        </React.Fragment>
                    )}
                </Col>
                <Col md={2}>
                    <BetterCheckBox
                        name={"debugMode"}
                        className={"mt-4"}
                        text={"Debug Mode"}
                        checked={requestData.debugMode}
                        onChange={(e) => handleFilterChange(e, "checkbox", "debugMode")}
                    />
                </Col>
            </Row>
            <hr/>
            <Row>
                <Col md={2}>
                    <Row>
                        <Col md={10}>
                            <Input
                                name={"srcdst"}
                                label={"Τηλέφωνο"}
                                value={requestData.srcdst}
                                onChange={(e) => handleFilterChange(e, "input", "srcdst")}
                            />
                        </Col>
                        <Col md={2}>
                            <Badge bg={"primary"} title={"Εμφάνιση εσωτερικών τηλεφώνων"} style={{cursor: "pointer", position: "absolute", left: "2px", top: "30px"}} onClick={() => setShowTelephonesModal(true)}>Τηλ.</Badge>
                        </Col>
                    </Row>
                </Col>
                <Col md={2}>
                    <Input
                        name={"client"}
                        label={"Όνομα/ΑΦΜ Πελάτη"}
                        value={requestData.client}
                        onChange={(e) => handleFilterChange(e, "input", "client")}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        name={"callType"}
                        label={"Τύπος Κλήσης"}
                        key={Math.random()}
                        options={callTypeOptions}
                        defaultValue={requestData.callType}
                        multiSelect={true}
                        onChange={(e) => handleFilterChange(e, "msdd", "callType")}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        name={"company"}
                        label={"Εταιρεία"}
                        key={Math.random()}
                        options={getDIDOptions()}
                        defaultValue={getMappedDefaultDids()}
                        multiSelect={true}
                        onChange={(e) => handleFilterChange(e, "msdd", "did")}
                    />
                </Col>
                <Col md={2}>
                    <Dropdown
                        name={"queue"}
                        label={"Ουρά"}
                        key={Math.random()}
                        options={getQueuesOptions()}
                        defaultValue={requestData.queue}
                        multiSelect={true}
                        onChange={(e) => handleFilterChange(e, "msdd", "queue")}
                    />
                </Col>
                <Col md={2}>
                    <Button onClick={() => fetchCDRViewer(false)} disabled={loading || requestData.needsFetch}>Ανανέωση δεδομένων από την Cache {loading && <Spinner animation="border" variant="dark" />}</Button>
                </Col>
            </Row>
            <Row>
                <Col md={2}>
                    <Dropdown
                        name={"aiStatus"}
                        label={"Κατάσταση AI"}
                        key={Math.random()}
                        options={aiStatusOptions}
                        defaultValue={requestData.aiStatus}
                        multiSelect={true}
                        onChange={(e) => handleFilterChange(e, "msdd", "aiStatus")}
                    />
                </Col>
                <Col md={4}>
                    <Dropdown
                        name={"tags"}
                        label={"AI Tags"}
                        key={Math.random()}
                        options={dynamicTagsOptions}
                        defaultValue={
                            requestData.tags && Array.isArray(requestData.tags)
                                ? dynamicTagsOptions.filter(opt => requestData.tags.includes(opt.value))
                                : []
                        }
                        multiSelect={true}
                        onChange={(e) => handleFilterChange(e, "msdd", "tags")}
                    />
                </Col>
                <Col md={4} className="mt-4">
                    <Button size="sm" onClick={() => setShowTagsModal(true)}>Διαχείριση AI Tags</Button>
                </Col>
            </Row>
            {responseData.totalPages > 0 && (
                <React.Fragment>
                    <hr className={"mt-1 mb-1"}/>
                    <Row className={"mb-2"}>
                        <div className="text-muted mb-1"><i>Στατιστικά & Αναφορές (πλην εσωτερικών κλήσεων)</i></div>
                        <Col md={2}>
                            <div className={"statBox"}>
                                <div className={"statBoxTitle"}>Συνολικές κλήσεις</div>
                                <hr className={"mt-1 mb-1"}/>
                                <div className={"statBoxContainer"} style={{textAlign: "center", fontSize: "20px"}}>{responseData.stats.totalInboundCalls + responseData.stats.totalOutboundCalls}</div>
                            </div>
                        </Col>
                        <Col md={2}>
                            <div className={"statBox"}>
                                <div className={"statBoxTitle"}>Συνολικές εισερχόμενες κλήσεις</div>
                                <hr className={"mt-1 mb-1"}/>
                                <div className={"statBoxContainer"} style={{textAlign: "center", fontSize: "20px"}}>{responseData.stats.totalInboundCalls}</div>
                            </div>
                        </Col>
                        <Col md={2}>
                            <div className={"statBox"}>
                                <div className={"statBoxTitle"}>Συνολικές εξερχόμενες κλήσεις</div>
                                <hr className={"mt-1 mb-1"}/>
                                <div className={"statBoxContainer"} style={{textAlign: "center", fontSize: "20px"}}>{responseData.stats.totalOutboundCalls}</div>
                            </div>
                        </Col>
                        <Col md={2}>
                            <div className={"statBox"}>
                                <div className={"statBoxTitle"}>Πλήθος εισερχόμενων κλήσεων που δεν απαντήθηκαν</div>
                                <hr className={"mt-1 mb-1"}/>
                                <div className={"statBoxContainer"} style={{textAlign: "center", fontSize: "20px"}}>
                                    {responseData.stats.noAnswer}<br/>
                                    <Badge bg={"primary"} style={{cursor: "pointer"}} onClick={() => setShowNoAnswerModal(true)}>Προβολή Ιστορικού</Badge>
                                </div>
                            </div>
                        </Col>
                        <Col md={2}>
                            <div className={"statBox"}>
                                <div className={"statBoxTitle"}>Μέσος χρόνος αναμονής ανά DID</div>
                                <hr className={"mt-1 mb-1"}/>
                                <div className={"statBoxContainer"} style={{textAlign: "center", fontSize: "16px"}}>
                                    {Object.keys(responseData.stats.meanDidWaitingTime).length > 0 ? Object.keys(responseData.stats.meanDidWaitingTime).map((did) => (
                                        <span>{did} : {minutesDoubleToText(responseData.stats.meanDidWaitingTime[did])}<br/></span>
                                    )) : (
                                        <span>Δεν υπήρχαν άτομα σε αναμονή σε κάποιο DID</span>
                                    )}
                                </div>
                            </div>
                        </Col>
                        <Col md={2}>
                            <div className={"statBox"}>
                                <div className={"statBoxTitle"}>Πλήθος μέγιστων κλήσεων ανά DID</div>
                                <hr className={"mt-1 mb-1"}/>
                                <div className={"statBoxContainer"} style={{textAlign: "center", fontSize: "16px"}}>
                                    {Object.keys(responseData.stats.maxSimultaneousCalls).length > 0 ? Object.keys(responseData.stats.maxSimultaneousCalls).map((did) => (
                                        <span>{did} : {responseData.stats.maxSimultaneousCalls[did]}<br/></span>
                                    )) : (
                                        <span>Δεν βρέθηκαν δεδομένα</span>
                                    )}
                                    {!isEmpty(responseData.stats.maxSimultaneousCallsTime) && (
                                        <span style={{fontSize: "14px"}}><i>Την στιγμή {responseData.stats.maxSimultaneousCallsTime}</i></span>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className="mb-3 justify-content-end">
                        <Col md={5}>
                            <Button size={"sm"} className={"mr-1"} onClick={() => handleExcelExport()} disabled={loading}>Εξαγωγή XLSX {loading && <Spinner animation="border" variant="dark" size={12}/>}</Button>
                            <Button size={"sm"} className={"mr-1"} variant="primary" onClick={() => handleMassTranscriptExport()} disabled={loading || exportingZip}>
                                {exportingZip ? <Spinner animation="border" size="sm" className="mr-1" /> : <MdFolderZip size={12} className="mr-1" />}
                                Εξαγωγή Transcripts
                            </Button>
                            <Button size={"sm"} className={"mr-1"} onClick={() => setShowChatHistoryModal(true)} disabled={loading} variant="primary">
                                <MdHistory size={12} className="mr-1" />Ιστορικό AI Chat
                            </Button>
                            <Button size={"sm"} onClick={() => { setExistingChatSession(null); setShowLiveChatModal(true); }} disabled={loading}>
                                <MdAutoAwesome size={12} className="mr-1" />Νέο AI Chat
                            </Button>
                        </Col>
                        <Col md={7} style={{display: "flex", justifyContent: "right"}}>
                            <Button
                                size="sm"
                                className="mr-1"
                                onClick={() => setShowMassSendAiModal(true)}
                                disabled={loading}
                            >
                                {selectedRows.length === 0 ? "Αποστολή φιλτραρισμένων στο AI" : "Αποστολή επιλεγμένων στο AI"}
                            </Button>
                            <Button size="sm" className="mr-1" onClick={() => firstPage()}
                                    disabled={requestData.page === 1 || loading}>{"<< Πρώτη"}</Button>
                            <Button size="sm" className="mr-1" onClick={() => previousPage()}
                                    disabled={requestData.page === 1 || loading}>{"< Προηγούμενη"}</Button>
                            <Badge style={{fontSize: "12px", lineHeight: "20px"}} className="mr-1" bg="primary">Σελίδα {requestData.page} / {responseData.totalPages}</Badge>
                            <Button size="sm" className="mr-1" onClick={() => nextPage()} disabled={requestData.page === responseData.totalPages || loading}>{"Επόμενη >"}</Button>
                            <Button size="sm" className="mr-1" onClick={() => lastPage()} disabled={requestData.page === responseData.totalPages || loading}>{"Τελευταία >>"}</Button>
                        </Col>
                    </Row>

                    {selectedRows.length > 0 && (
                        <div className="d-flex align-items-center mb-2 p-2 bg-light border rounded">
                            <i>
                                Έχετε επιλέξει {selectedRows.includes("-1")
                                ? (requestData.totalItems) - selectedRows.filter((el) => el !== "-1").length
                                : selectedRows.length} κλήσεις
                            </i>
                            <div className="ai-module-button ai-module-reprocess-style ml-3 pr-2 text-danger"
                                 title="Αποεπιλογή"
                                 onClick={() => setSelectedRows([])}
                                 style={{cursor: "pointer", fontWeight: "bold"}}>
                                <MdDeselect size={20} /> Αποεπιλογή όλων
                            </div>
                        </div>
                    )}

                    {(() => {
                        const localProcessingCount = responseData?.data?.filter(row =>
                            row.aiStatus !== null && row.aiStatus !== undefined && row.aiStatus !== "" &&
                            Number(row.aiStatus) >= 0 && Number(row.aiStatus) < 100 && Number(row.aiStatus) !== 4
                        ).length;

                        const totalProcessing = Math.max(localProcessingCount, manualProcessingIds.length);

                        if (totalProcessing > 0) {
                            return (
                                <div className="d-flex align-items-center mb-2 p-2 border rounded bg-light">
                                    <MdHourglassEmpty size={20} className="mr-2 text-primary" />
                                    <i>
                                        <strong>{totalProcessing} {totalProcessing === 1 ? "κλήση βρίσκεται" : "κλήσεις βρίσκονται"}</strong> σε AI ανάλυση στο παρασκήνιο
                                    </i>
                                </div>
                            );
                        }
                        return null;
                    })()}

                    <Row className={"mt-2 mb-2"}>
                        {requestData.debugMode ? (
                            <Col md={12}>
                                <table className="table-hover" style={{tableLayout: "fixed", textAlign: "center", width: "100%", border: "1px solid gray"}}>
                                    <colgroup>
                                        {tableColumns.map((o) => (
                                            <col span={1} key={o.field + "col"} style={{width: o.width}}></col>
                                        ))}
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        {tableColumns.map((o) => (
                                            <th key={o.field} style={{border: "1px solid gray", backgroundColor: "#f1fdff"}}>
                                                {o.field === "select_checkbox" ? (
                                                    <input
                                                        type="checkbox"
                                                        onChange={handleSelectAll}
                                                        checked={isAllChecked}
                                                        style={{cursor: "pointer", width: "16px", height: "16px"}}
                                                        title="Επιλογή Όλων"
                                                    />
                                                ) : o.name}
                                            </th>
                                        ))}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {responseData.data?.length > 0 && responseData.data.map((row) => (
                                        <tr
                                            title={
                                                row.aiStatus === 100 ? "Προβολή ανάλυσης από AI" :
                                                    Number(row.aiStatus) === 4 ? "" :
                                                        (row.aiStatus !== null && row.aiStatus !== undefined && row.aiStatus !== "" && Number(row.aiStatus) >= 0 && Number(row.aiStatus) < 100) ? "Ανάλυση σε εξέλιξη..." :
                                                            (row.aiStatus !== null && row.aiStatus !== undefined && row.aiStatus !== "" && Number(row.aiStatus) < 0) ? "Η ανάλυση απέτυχε" : ""
                                            }
                                            key={row.sequence}
                                            onClick={() => row.aiStatus === 100 && handleClickAi(row)}
                                            className={row.aiStatus === 100 ? "ai-row-clickable" : ""}
                                            style={{cursor: row.aiStatus === 100 ? "pointer" : ""}}
                                        >
                                            {tableColumns.map((o) => {
                                                if (o.field === "select_checkbox") {
                                                    return (
                                                        <td key={o.field + row.sequence} style={{border: "1px solid gray"}}>
                                                            <input
                                                                type="checkbox"
                                                                checked={
                                                                    selectedRows.includes("-1")
                                                                        ? !selectedRows.includes(String(row.linkedid))
                                                                        : selectedRows.includes(String(row.linkedid))
                                                                }
                                                                onChange={(e) => handleSelectRow(e, row.linkedid)}
                                                                onClick={(e) => e.stopPropagation()}
                                                                style={{cursor: "pointer", width: "16px", height: "16px"}}
                                                            />
                                                        </td>
                                                    )
                                                } else if (o.field === "calldate") {
                                                    return (<td key={o.name + row.sequence} style={{border: "1px solid gray"}}>{moment(row[o.field]).format("DD/MM/YYYY HH:mm:ss")}</td>)
                                                } else if (o.field === "waiting") {
                                                    return (<td key={o.name + row.sequence} style={{border: "1px solid gray"}}>{Number(row["duration"]) - Number(row["billsec"])}</td>)
                                                } else if (o.field === "AISubject") {
                                                    const aiStatusNum = (row.aiStatus !== null && row.aiStatus !== undefined && row.aiStatus !== "") ? Number(row.aiStatus) : null;
                                                    const isManual = manualProcessingIds.includes(String(row.linkedid)) || aiStatusNum === 0;
                                                    const isBatchProcessing = aiStatusNum > 0 && aiStatusNum < 100 && aiStatusNum !== 4 && !isManual;
                                                    const isAiFailed = aiStatusNum !== null && aiStatusNum < 0 && !isManual;
                                                    const fullText = row.aiMainSubject ? row.aiMainSubject : "";
                                                    const maxLength = 50;
                                                    const displayText = fullText.length > maxLength ? fullText.substring(0, maxLength) + "..." : fullText;

                                                    return (
                                                        <td key={o.name + row.sequence}
                                                            style={{border: "1px solid gray"}}>
                                                            {isBatchProcessing ? (
                                                                <Badge bg="secondary">
                                                                    <MdHourglassEmpty size={12}/> Σε ουρά Batch...
                                                                </Badge>
                                                            ) : isAiFailed ? (
                                                                <span className="text-danger" style={{
                                                                    fontSize: "12px",
                                                                    fontWeight: "bold"
                                                                }}>Απέτυχε</span>
                                                            ) : (
                                                                displayText
                                                            )}
                                                        </td>
                                                    )
                                                } else if (o.field === "AITags") {
                                                    const tagsData = row.aiTags;

                                                    return (
                                                        <td key={o.name + row.sequence} style={{ border: "1px solid gray", padding: "4px" }}>
                                                            <div className="d-flex flex-wrap justify-content-center" style={{ gap: "4px" }}>
                                                                {Array.isArray(tagsData) && tagsData.length > 0 ? (
                                                                    tagsData.map((fullTagString, idx) => {
                                                                        const parts = fullTagString.split("|");
                                                                        const tagName = parts[0]?.trim() || fullTagString;
                                                                        const companyName = parts[1]?.trim() || "";

                                                                        return (
                                                                            <Badge
                                                                                key={idx}
                                                                                bg="primary"
                                                                                style={{
                                                                                    fontSize: "11px",
                                                                                    padding: "4px 6px",
                                                                                    cursor: "default"
                                                                                }}
                                                                            >
                                                                                {tagName}
                                                                                {companyName && (
                                                                                    <span style={{
                                                                                        opacity: 0.8,
                                                                                        marginLeft: "4px",
                                                                                        fontSize: "11px",
                                                                                        borderLeft: "1px solid white",
                                                                                        paddingLeft: "4px"
                                                                                    }}>
                                                                                        {companyName}
                                                                                    </span>
                                                                                )}
                                                                            </Badge>
                                                                        );
                                                                    })
                                                                ) : ""}
                                                            </div>
                                                        </td>
                                                    );
                                                } else if (o.field === "actions") {
                                                    const isAiReady = row.hasAiAnalysis || Number(row.aiStatus) === 100;
                                                    const isProcessing = row.aiStatus !== null && row.aiStatus !== undefined && row.aiStatus !== "" && Number(row.aiStatus) >= 0 && Number(row.aiStatus) < 100 && Number(row.aiStatus) !== 4;
                                                    const isAiFailed = row.aiStatus !== null && row.aiStatus !== undefined && row.aiStatus !== "" && Number(row.aiStatus) < 0;
                                                    const isManual = manualProcessingIds.includes(String(row.linkedid));

                                                    return (
                                                        <td key={o.name + row.sequence} style={{border: "1px solid gray"}}>
                                                            <div className="d-flex justify-content-center gap-1">
                                                                {!isEmpty(row.recordingfile) && (
                                                                    <Badge
                                                                        style={{cursor: !loading ? "pointer" : ""}}
                                                                        bg={"primary"}
                                                                        onClick={(e) => { e.stopPropagation(); fetchRecording(row); }}
                                                                        hidden={loading}
                                                                        title="Λήψη κλήσης"
                                                                    >
                                                                        {loading ? <Spinner animation="border" size="sm" variant="light" /> : <MdFileDownload size={16} color="white" />}
                                                                    </Badge>
                                                                )}
                                                                {isProcessing && isManual ? (
                                                                    <Badge
                                                                        bg="primary"
                                                                        style={{ cursor: "wait" }}
                                                                        title="Η ανάλυση είναι σε εξέλιξη..."
                                                                    >
                                                                        <Spinner animation="border" size="sm" variant="light" style={{ width: '14px', height: '14px', borderWidth: '0.15em' }} />
                                                                    </Badge>
                                                                ) : isAiFailed ? (
                                                                    <Badge
                                                                        bg="danger"
                                                                        title="Η ανάλυση AI απέτυχε οριστικά."
                                                                        style={{ cursor: "not-allowed" }}
                                                                    >
                                                                        <MdError size={16} color="white" />
                                                                    </Badge>
                                                                ) : isAiReady ? (
                                                                    <Badge
                                                                        style={{ cursor: (!aiLoading && isAiReady) ? "pointer" : "not-allowed" }}
                                                                        bg="primary"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            if (!aiLoading && isAiReady) handleClickAi(row);
                                                                        }}
                                                                        title="Προβολή ανάλυσης από AI"
                                                                    >
                                                                        {aiLoading && processingLinkedId === row.linkedid ? (
                                                                            <Spinner animation="border" size="sm" variant="light" />
                                                                        ) : (
                                                                            <MdAutoAwesome size={16} color="white" />
                                                                        )}
                                                                    </Badge>
                                                                ) : null}
                                                            </div>
                                                        </td>
                                                    )
                                                } else {
                                                    return (<td key={o.name + row.sequence} style={{border: "1px solid gray"}}>{row[o.field]}</td>)
                                                }
                                            })}
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </Col>
                        ) : (
                            <Col md={12}>
                                <table className="table-hover" style={{tableLayout: "fixed", textAlign: "center", width: "100%", border: "1px solid gray"}}>
                                    <colgroup>
                                        {tableColumnsSimpleView.map((o) => (
                                            <col span={1} key={o.field + "col"} style={{width: o.width}}></col>
                                        ))}
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        {tableColumnsSimpleView.map((o) => (
                                            <th key={o.field} style={{border: "1px solid gray", backgroundColor: "#f1fdff"}}>
                                                {o.field === "select_checkbox" ? (
                                                    <input
                                                        type="checkbox"
                                                        onChange={handleSelectAll}
                                                        checked={isAllChecked}
                                                        style={{cursor: "pointer", width: "16px", height: "16px"}}
                                                        title="Επιλογή Όλων"
                                                    />
                                                ) : o.name}
                                            </th>
                                        ))}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {responseData.data?.length > 0 && responseData.data.map((row) => (
                                        <tr
                                            title={
                                                row.aiStatus === 100 ? "Προβολή ανάλυσης από AI" :
                                                    Number(row.aiStatus) === 4 ? "" :
                                                        (row.aiStatus !== null && row.aiStatus !== undefined && row.aiStatus !== "" && Number(row.aiStatus) >= 0 && Number(row.aiStatus) < 100) ? "Ανάλυση σε εξέλιξη..." :
                                                            (row.aiStatus !== null && row.aiStatus !== undefined && row.aiStatus !== "" && Number(row.aiStatus) < 0) ? "Η ανάλυση απέτυχε" : ""
                                            }
                                            key={row.sequence}
                                            onClick={() => row.aiStatus === 100 && handleClickAi(row)}
                                            className={row.aiStatus === 100 ? "ai-row-clickable" : ""}
                                            style={{cursor: row.aiStatus === 100 ? "pointer" : ""}}
                                        >
                                            {tableColumnsSimpleView.map((o) => {
                                                if (o.field === "select_checkbox") {
                                                    return (
                                                        <td key={o.field + row.sequence} style={{border: "1px solid gray"}}>
                                                            <input
                                                                type="checkbox"
                                                                checked={
                                                                    selectedRows.includes("-1")
                                                                        ? !selectedRows.includes(String(row.linkedid))
                                                                        : selectedRows.includes(String(row.linkedid))
                                                                }
                                                                onChange={(e) => handleSelectRow(e, row.linkedid)}
                                                                onClick={(e) => e.stopPropagation()}
                                                                style={{cursor: "pointer", width: "16px", height: "16px"}}
                                                            />
                                                        </td>
                                                    )
                                                } else if (o.field === "calldate") {
                                                    return (<td key={o.name + row.sequence} style={{border: "1px solid gray"}}>{moment(row[o.field]).format("DD/MM/YYYY HH:mm:ss")}</td>)
                                                } else if (o.field === "waiting") {
                                                    return (<td key={o.name + row.sequence} style={{border: "1px solid gray"}}>{secondsToMinutesSeconds(Number(row["duration"]) - Number(row["billsec"]))}</td>)
                                                } else if (o.field === "duration") {
                                                    return (<td key={o.name + row.sequence} style={{border: "1px solid gray"}}>{secondsToMinutesSeconds(Number(row["duration"]))}</td>)
                                                } else if (o.field === "billsec") {
                                                    return (<td key={o.name + row.sequence} style={{border: "1px solid gray"}}>{secondsToMinutesSeconds(Number(row["billsec"]))}</td>)
                                                } else if (o.field === "AISubject") {
                                                    const aiStatusNum = (row.aiStatus !== null && row.aiStatus !== undefined && row.aiStatus !== "") ? Number(row.aiStatus) : null;
                                                    const isManual = manualProcessingIds.includes(String(row.linkedid)) || aiStatusNum === 0;
                                                    const isBatchProcessing = aiStatusNum > 0 && aiStatusNum < 100 && aiStatusNum !== 4 && !isManual;
                                                    const isAiFailed = aiStatusNum !== null && aiStatusNum < 0 && !isManual;
                                                    const fullText = row.aiMainSubject ? row.aiMainSubject : "";
                                                    const maxLength = 50;
                                                    const displayText = fullText.length > maxLength ? fullText.substring(0, maxLength) + "..." : fullText;

                                                    return (
                                                        <td key={o.name + row.sequence} style={{border: "1px solid gray"}}>
                                                            {isBatchProcessing ? (
                                                                <Badge bg="secondary">
                                                                    <MdHourglassEmpty size={12}/> Σε ουρά Batch...
                                                                </Badge>
                                                            ) : isAiFailed ? (
                                                                <span className="text-danger" style={{fontSize: "12px", fontWeight: "bold"}}>Απέτυχε</span>
                                                            ) : (
                                                                displayText
                                                            )}
                                                        </td>
                                                    )
                                                } else if (o.field === "AITags") {
                                                    const tagsData = row.aiTags;

                                                    return (
                                                        <td key={o.name + row.sequence} style={{ border: "1px solid gray", padding: "4px" }}>
                                                            <div className="d-flex flex-wrap justify-content-center" style={{ gap: "4px" }}>
                                                                {Array.isArray(tagsData) && tagsData.length > 0 ? (
                                                                    tagsData.map((fullTagString, idx) => {
                                                                        const parts = fullTagString.split("|");
                                                                        const tagName = parts[0]?.trim() || fullTagString;
                                                                        const companyName = parts[1]?.trim() || "";

                                                                        return (
                                                                            <Badge
                                                                                key={idx}
                                                                                bg="primary"
                                                                                style={{
                                                                                    fontSize: "11px",
                                                                                    padding: "4px 6px",
                                                                                    cursor: "default"
                                                                                }}
                                                                                title={`Εταιρεία: ${companyName || 'Άγνωστη'}`}
                                                                            >
                                                                                {tagName}
                                                                                {companyName && (
                                                                                    <span style={{
                                                                                        opacity: 0.8,
                                                                                        marginLeft: "4px",
                                                                                        fontSize: "11px",
                                                                                        borderLeft: "1px solid white",
                                                                                        paddingLeft: "4px"
                                                                                    }}>
                                                                                        {companyName}
                                                                                    </span>
                                                                                )}
                                                                            </Badge>
                                                                        );
                                                                    })
                                                                ) : ""}
                                                            </div>
                                                        </td>
                                                    );
                                                } else if (o.field === "actions") {
                                                    const isAiReady = row.hasAiAnalysis || Number(row.aiStatus) === 100;
                                                    const isProcessing = row.aiStatus !== null && row.aiStatus !== undefined && row.aiStatus !== "" && Number(row.aiStatus) >= 0 && Number(row.aiStatus) < 100 && Number(row.aiStatus) !== 4;
                                                    const isAiFailed = row.aiStatus !== null && row.aiStatus !== undefined && row.aiStatus !== "" && Number(row.aiStatus) < 0;
                                                    const isManual = manualProcessingIds.includes(String(row.linkedid));

                                                    return (
                                                        <td key={o.name + row.sequence} style={{border: "1px solid gray"}}>
                                                            <div className="d-flex justify-content-center gap-1">
                                                                {!isEmpty(row.recordingfile) && (
                                                                    <Badge
                                                                        style={{cursor: !loading ? "pointer" : ""}}
                                                                        bg={"primary"}
                                                                        onClick={(e) => { e.stopPropagation(); fetchRecording(row); }}
                                                                        hidden={loading}
                                                                        title="Λήψη κλήσης"
                                                                    >
                                                                        {loading ? <Spinner animation="border" size="sm" variant="light" /> : <MdFileDownload size={16} color="white" />}
                                                                    </Badge>
                                                                )}
                                                                {isProcessing && isManual ? (
                                                                    <Badge
                                                                        bg="primary"
                                                                        style={{ cursor: "wait" }}
                                                                        title="Η ανάλυση είναι σε εξέλιξη..."
                                                                    >
                                                                        <Spinner animation="border" size="sm" variant="light" style={{ width: '14px', height: '14px', borderWidth: '0.15em' }} />
                                                                    </Badge>
                                                                ) : isAiFailed ? (
                                                                    <Badge
                                                                        bg="danger"
                                                                        title="Η ανάλυση AI απέτυχε οριστικά."
                                                                        style={{ cursor: "not-allowed" }}
                                                                    >
                                                                        <MdError size={16} color="white" />
                                                                    </Badge>
                                                                ) : isAiReady ? (
                                                                    <Badge
                                                                        style={{ cursor: (!aiLoading && isAiReady) ? "pointer" : "not-allowed" }}
                                                                        bg="primary"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            if (!aiLoading && isAiReady) handleClickAi(row);
                                                                        }}
                                                                        title="Προβολή ανάλυσης από AI"
                                                                    >
                                                                        {aiLoading && processingLinkedId === row.linkedid ? (
                                                                            <Spinner animation="border" size="sm" variant="light" />
                                                                        ) : (
                                                                            <MdAutoAwesome size={16} color="white" />
                                                                        )}
                                                                    </Badge>
                                                                ) : null}
                                                            </div>
                                                        </td>
                                                    )
                                                } else {
                                                    return (<td key={o.name + row.sequence} style={{border: "1px solid gray"}}>{row[o.field]}</td>)
                                                }
                                            })}
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                <Row className={"d-flex justify-content-end mt-3"}>
                                    <Col md={4}>
                                        <div className={"text-muted mb-1"}><i>Χρόνος ομιλίας ανά εσωτερική γραμμή (μη συμπ. εσωτερικών κλήσεων)</i></div>
                                        <table className={"simpleClassicTable"}>
                                            <thead>
                                            <tr>
                                                <th>Εσωτερική γραμμή</th>
                                                <th>Χρόνος ομιλίας</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {Object.keys(responseData.totalsPerInner)
                                                .slice()
                                                .sort((a, b) => responseData.totalsPerInner[a] < responseData.totalsPerInner[b] ? 1 : -1)
                                                .map((inner, idx) => (
                                                    <tr key={`perInnerTotals-${idx}`}>
                                                        <td>{inner}</td>
                                                        <td>{secondsToMinutesSeconds(responseData.totalsPerInner[inner])}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </Col>
                                    <Col md={4}>
                                        <div className={"text-muted mb-1"}><i>Γενικά σύνολα</i></div>
                                        <table className={"simpleClassicTable"}>
                                            <tbody>
                                            <tr>
                                                <td><strong>Συνολικός χρόνος ομιλίας</strong></td>
                                                <td>{secondsToMinutesSeconds(responseData.totals.billsec)}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Συνολικός χρόνος αναμονής</strong></td>
                                                <td>{secondsToMinutesSeconds(responseData.totals.waiting)}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Σύνολο</strong></td>
                                                <td>{secondsToMinutesSeconds(responseData.totals.duration)}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Συνολικό AI Κόστος</strong></td>
                                                <td>{getGreekCurrencyFormat(responseData.stats.totalAiCost)} για {responseData.stats.totalAiAnalyzedCalls} Κλήσεις</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </Col>
                                </Row>
                            </Col>
                        )}
                    </Row>
                </React.Fragment>
            )}
            <Modal backdrop={"static"} show={showTelephonesModal} onHide={() => setShowTelephonesModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Εσωτερικά Τηλέφωνα</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {responseData.devices?.length > 0 && [...responseData.devices].sort((a, b) => Number(a.user) < Number(b.user) ? -1 : 1).map((device) => (
                        <Badge bg={"primary"} className={"mr-1 mb-2"} onClick={() => handleTelephoneClick(device)}
                               style={{cursor: "pointer"}}
                        >{device.user} | {device.description}</Badge>
                    ))}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowTelephonesModal(false)}>Κλείσιμο</Button>
                </Modal.Footer>
            </Modal>

            <Modal backdrop={"static"} show={showNoAnswerModal} onHide={() => setShowNoAnswerModal(false)} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Ιστορικό εισερχόμενων κλήσεων που δεν απαντήθηκαν</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {responseData?.stats?.noAnswerArr?.length > 0 ? (
                        <table style={{tableLayout: "fixed", textAlign: "center", width: "100%"}}>
                            <colgroup>
                                <col span={1} style={{width: "10%"}}></col>
                                <col span={1} style={{width: "10%"}}></col>
                                <col span={1} style={{width: "20%"}}></col>
                                <col span={1} style={{width: "5%"}}></col>
                                <col span={1} style={{width: "5%"}}></col>
                                <col span={1} style={{width: "10%"}}></col>
                                <col span={1} style={{width: "20%"}}></col>
                                <col span={1} style={{width: "10%"}}></col>
                            </colgroup>
                            <thead>
                            <tr>
                                <th style={{border: "1px solid gray"}}>Ημερομηνία</th>
                                <th style={{border: "1px solid gray"}}>Από</th>
                                <th style={{border: "1px solid gray"}}>Προς</th>
                                <th style={{border: "1px solid gray"}}>Χρόνος αναμονής</th>
                                <th style={{border: "1px solid gray"}}>Συνολικός χρόνος κλήσης</th>
                                <th style={{border: "1px solid gray"}}>Ουρές προσπέλασης</th>
                                <th style={{border: "1px solid gray"}}>Όνομα Πελάτη</th>
                                <th style={{border: "1px solid gray"}}>ΑΦΜ Πελάτη</th>
                            </tr>
                            </thead>
                            <tbody>
                            {responseData?.stats?.noAnswerArr.map((noAns, idx) => (
                                <React.Fragment>
                                    <tr key={idx + " noAnsTable"}>
                                        <td style={{border: "1px solid gray"}}>{noAns.date}</td>
                                        <td style={{border: "1px solid gray"}}>{noAns.src}</td>
                                        <td style={{border: "1px solid gray"}}>{noAns.dst === "s" ? dcontextToIvr(noAns.dcontext) : noAns.dst}</td>
                                        <td style={{border: "1px solid gray"}}>{secondsToMinutesSeconds(Number(noAns.ringing_duration))}</td>
                                        <td style={{border: "1px solid gray"}}>{secondsToMinutesSeconds(Number(noAns.call_duration))}</td>
                                        <td style={{border: "1px solid gray"}}>{noAns.queueHistory}</td>
                                        <td style={{border: "1px solid gray"}}>{noAns.clientName ? noAns.clientName : ""}</td>
                                        <td style={{border: "1px solid gray"}}>{noAns.clientVAT ? noAns.clientVAT : ""}</td>
                                    </tr>
                                </React.Fragment>
                            ))}
                            </tbody>
                        </table>
                    ) : (
                        <div>Δεν υπάρχουν κλήσεις.</div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowNoAnswerModal(false)}>Κλείσιμο</Button>
                </Modal.Footer>
            </Modal>

            <AICallAnalysisModal
                show={aiLoading || aiCallTranscription !== null}
                onHide={() => {
                    setAiLoading(false);
                    setAICallTranscription(null);
                    setAiAnalysisDate(null);
                    setAiCost(null);
                }}
                data={aiCallTranscription}
                analysisDate={aiAnalysisDate}
                cost={aiCost}
                isLoading={aiLoading}
                row={selectedCall}
            />

            <SendCDRCallsToAiModal
                show={showMassSendAiModal}
                setShow={setShowMassSendAiModal}
                selectedRows={selectedRows}
                filters={{...requestData, did: getActualDidsForBackend()}}
                successfulCallback={(sentIds, isBatch) => {
                    const idsToProcess = (sentIds && Array.isArray(sentIds)) ? sentIds : selectedRows;
                    if (!idsToProcess.includes("-1")) {
                        const updatedData = responseData.data.map(row => {
                            if (idsToProcess.includes(String(row.linkedid))) {
                                return {
                                    ...row,
                                    aiStatus: isBatch ? 2 : 0,
                                    hasAiAnalysis: false,
                                    aiTags: [],
                                    aiMainSubject: ""
                                };
                            }
                            return row;
                        });

                        dispatch(setCDRViewerResponseData({
                            ...responseData,
                            data: updatedData
                        }));

                        if (!isBatch) {
                            setManualProcessingIds(prev => {
                                const newIds = idsToProcess.filter(id => !prev.includes(id));
                                return [...prev, ...newIds];
                            });
                        }
                    } else {
                        fetchCDRViewer(false, false, true);
                    }

                    setSelectedRows([]);
                    setSelectedCall(null);
                }}
            />

            <AICDRTagsModal
                show={showTagsModal}
                onHide={() => setShowTagsModal(false)}
            />

            <AIChatHistoryModal
                show={showChatHistoryModal}
                onHide={() => setShowChatHistoryModal(false)}
                onSelectSession={(session) => {
                    setExistingChatSession(session);
                    setShowChatHistoryModal(false);
                    setShowLiveChatModal(true);
                }}
            />

            <AILiveChatModal
                show={showLiveChatModal}
                onHide={() => setShowLiveChatModal(false)}
                callsData={responseData?.data || []}
                selectedRows={selectedRows}
                filters={{...requestData, did: getActualDidsForBackend()}}
                companyId={company.id}
                existingSession={existingChatSession}
            />
        </div>
    )
}